






































































import {Vue, Component, Ref} from 'vue-property-decorator';
import MallSelect from '@/components/common/claim/contentTop/MallSelect.vue';
import { Getter } from 'vuex-class';
import { Mall, ProductExcelBulkAdminUpdate } from 'supporter';
import CompSelectBox from '@/components/common/CompSelectBox.vue';
import { NCPResponse } from 'ncp-api-supporter';
import { saveBinaryDataToFile } from '@/utils/fileSaver';
import { ValidOption } from '@/components/common/input/FileInputMixin.vue';
import FileInput from '@/components/common/input/FileInput.vue';
import { Admin } from '@/types';
import moment from 'moment';

@Component({
  components: {
    MallSelect,
    CompSelectBox,
    FileInput
  }
})
export default class ChangeAdmin extends Vue {
  @Getter('mall/malls')
  private malls: Mall[];
  @Getter('admin/admin')
  private readonly admin: Admin;

  @Ref() private readonly mallSelectRef!: MallSelect;
  @Ref() private readonly fileInputRef: FileInput;

  private uploadedExcelFileName = '';
  private extensionValidOption: ValidOption<string> = {
    validType: 'excel',
    alertMsg: 'ALERT_DISALLOW_EXTENSION',
  };
  private uploadedExcelFile: File | null = null;
  private mallNo = 0;
  private isProcessing = false;
  private today  = moment(new Date()).format('YYYYMMDD');


  get dialogues(): string[] {
    return this.$t('PRODUCT_POP_PRODUCTLIST_CHANGE_ADMIN_DIALOGUES')
      .toString()
      .trim()
      .split('\n');
  }

  private get mallSelectList(){
    return this.malls.map(mall => ({
      option: mall.mallName,
      value: mall.mallNo
    }));
  }

  private changeMall(mallNo: string) {
    this.mallNo = Number(mallNo);
  }

  private async downloadExcel() {
    const { data }: NCPResponse<ArrayBuffer> = await this.$api.getProductsExcelUpdateAdminForm();
    const fileName = `${this.$t('PRODUCT_POP_PRODUCTLIST_CHANGE_PRODUCT_ADMIN_EXCEL_FORM_NAME')}_${this.today}.xlsx`;
    saveBinaryDataToFile(data, fileName);
  }

  private uploadExcelFile(file: File): void {
    this.uploadedExcelFileName = file.name;
    this.uploadedExcelFile = file;
  }

  private removeFile(): void {
    this.uploadedExcelFile = null;
    this.uploadedExcelFileName = '';
    this.fileInputRef.clearFile();
    this.fileInputRef.resetFileName();
  }

  private async save() {
    if (!this.mallNo) {
      this.mallSelectRef.focus();
      return alert(this.$t('COMMON_ERR_MALLNO_NULL'));
    }

    if (!this.uploadedExcelFileName) return alert(this.$t('COMMON_NO_EXCEL_ERROR'));

    this.updateProductsAdminsWithLoading();
  }

  private updateProductsAdminsWithLoading() {
    this.isProcessing = true;
    this.updateProductsAdmins().finally(() => {
      this.isProcessing = false;
      this.resetPopData();
    });
  }

  private async updateProductsAdmins() {
    const formData = new FormData();
    formData.append('excelFile', this.uploadedExcelFile);
    try {
      const { data }: NCPResponse<ProductExcelBulkAdminUpdate> = await this.$api.putProductsExcelBulkAdminUpdate({
        params: { mallNo: this.mallNo },
        data: formData,
      });
      this.updateExcelResult(data);
    } catch (e) {
      console.error(e);
    }
  }

  private updateExcelResult(excelResultData: ProductExcelBulkAdminUpdate) {
    const { totalSuccessCount, totalFailCount, failExcelId } = excelResultData;
    const upddateResultMessage = this.$t('PRODUCT_POP_PRODUCTLIST_ALERT_ADMIN_CHANGE_COMPLETE');
    const successCountMessage = this.$t('SUCCESS_N', { count: totalSuccessCount }).toString();
    const failCountMessage = this.$t('FAIL_N', { count: totalFailCount }).toString();

    //성공만
    if (totalSuccessCount > 0 && totalFailCount <= 0) {
      alert(`${upddateResultMessage}\n${successCountMessage}`);
      window.opener.location.reload();
    }
    //실패만
    if (totalFailCount > 0 && totalSuccessCount <= 0) {
      alert(`${upddateResultMessage}\n${failCountMessage}`);
      this.downloadFailedExcel(failExcelId);
    }
    //성공+실패
    if (totalSuccessCount > 0 && totalFailCount > 0) {
      alert(`${upddateResultMessage}\n${successCountMessage}, ${failCountMessage}`);
      this.downloadFailedExcel(failExcelId);
      window.opener.location.reload();
    }
  }

  private async downloadFailedExcel(failExcelId: string) {
    const fileName = `${this.$t('PRODUCT_POP_PRODUCTLIST_FAILED_CHANGE_PRODUCT_ADMIN_EXCEL_NAME')}_${this.today}.xlsx`;
    try {
      const { data }: NCPResponse<ArrayBuffer> = await this.$api.getProductsExcelProductAdminFail({
        params: { failExcelId },
        responseType: 'arraybuffer',
      });
      saveBinaryDataToFile(data, fileName);
    } catch (e) {
      console.error(e);
    }
  }

  private resetPopData() {
    this.mallNo = 0;
    this.removeFile();
  }

  private close() {
    window.close();
  }

  created() {
    document.body.classList.add('popup');
    window.name = 'changeAdmin';
  }
}
